import { render, staticRenderFns } from "./editOrderMan.vue?vue&type=template&id=db4d963c&scoped=true&"
import script from "./editOrderMan.vue?vue&type=script&lang=js&"
export * from "./editOrderMan.vue?vue&type=script&lang=js&"
import style0 from "./editOrderMan.vue?vue&type=style&index=0&id=db4d963c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4d963c",
  null
  
)

export default component.exports